module.exports = __webpack_public_path__ + "static/img/Brandon-Smith.2c5ee85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brandon-Smith.jpg
// module id = nUJu
// module chunks = 0